import React from 'react'
import FullScreen1 from '../../../assets/customPlayer/fullScreen/fullScreen1'
import FullScreen2 from '../../../assets/customPlayer/fullScreen/fullScreen2'
import FullScreen3 from '../../../assets/customPlayer/fullScreen/fullScreen3'
import FullScreen4 from '../../../assets/customPlayer/fullScreen/fullScreen4'
import FullScreen5 from '../../../assets/customPlayer/fullScreen/fullScreen5'
import FullScreen6 from '../../../assets/customPlayer/fullScreen/fullScreen6'

const FullScreenButton = (props) => {
  let { isFullScreen, toggleFullScreen, data } = props

  let icons = {
    FULL_SCREEN1: (
      <>
        <FullScreen1 isFullScreen={isFullScreen} color={data.icon_color} />
      </>
    ),
    FULL_SCREEN2: (
      <>
        <FullScreen2 isFullScreen={isFullScreen} color={data.icon_color} />
      </>
    ),
    FULL_SCREEN3: (
      <>
        <FullScreen3 isFullScreen={isFullScreen} color={data.icon_color} />
      </>
    ),
    FULL_SCREEN4: (
      <>
        <FullScreen4 isFullScreen={isFullScreen} color={data.icon_color} />
      </>
    ),
    FULL_SCREEN5: (
      <>
        <FullScreen5 isFullScreen={isFullScreen} color={data.icon_color} />
      </>
    ),
    FULL_SCREEN6: (
      <>
        <FullScreen6 isFullScreen={isFullScreen} color={data.icon_color} />
      </>
    ),
  }

  return (
    <div className="h-full" style={{ padding: '2px 0' }}>
      {data.visible ? (
        <div
          className="flex justify-center items-center w-auto h-full cursor-pointer"
          onClick={() => toggleFullScreen(!isFullScreen)}
        >
          {icons[data.icon_type]}
        </div>
      ) : null}
    </div>
  )
}

export default FullScreenButton
